/**
 * Site-wide configuration constants for Red Rock Ponds RV Resort
 * Update these values annually or as pricing/policies change
 */

// Current operating season
export const SEASON_YEAR = 2026;

export const SEASON_DATES = {
  openingDate: 'May 1st',
  closingDate: 'Oct 18th'
};

// Announcement banner
export const ANNOUNCEMENT = {
  badge: `${SEASON_YEAR} SEASON`,
  message: `We Will Open for the Season ${SEASON_DATES.openingDate}, ${SEASON_YEAR}.`,
  button: {
    text: 'Make Your Reservation',
    link: '/reservation'
  }
};

// Pricing information
export const PRICING = {
  daily: {
    weekday: 50.00,
    weekend: 64.00,
    holiday: 79.00
  },
  weekly: {
    regular: 330,
    peak: 355, // July-August
    peakMonths: 'Jul-Aug'
  },
  monthly: {
    base: 775,
    note: '+ Electric' 
  },
  golfCart: {
    weekday: 60, // Sunday-Thursday
    weekend: 85, // Friday & Saturday
    weekdayLabel: 'Sun-Thu',
    weekendLabel: 'Fri & Sat'
  },
  notes: {
    holiday: 'Holidays refers to long weekends only (Memorial Day weekend etc). 3 day minimum on holidays. Weekend rate may increase on selected dates.',
    weeklyHoliday: 'Rate may increase by $25/day for dates overlapping long weekend holidays.',
    monthlyHoliday: 'Rate may increase by $25/day for dates overlapping long weekend holidays.',
    golfCart: 'Electric club carts. 2 night minimum (3 night minimum on holidays and special events).'
  }
};

// Contact information
export const CONTACT = {
  phone: '(585) 638-2445',
  email: 'contactus@redrockponds.com',
  address: {
    street: '16097 Canal Rd.',
    city: 'Holley',
    state: 'NY',
    zip: '14470',
    full: '16097 Canal Rd., Holley, NY 14470'
  },
  location: {
    lat: 43.255249,
    lng: -78.077096
  }
};

// Office hours
export const HOURS = {
  sunThu: '10 AM - 4 PM',
  fri: '10 AM - 7 PM',
  sat: '10 AM - 6 PM'
};

// Social media links
export const SOCIAL_MEDIA = {
  facebook: 'https://www.facebook.com/RedRockPonds',
  instagram: 'https://www.instagram.com/redrockponds/',
  twitter: 'https://twitter.com/redrockponds'
};

// Booking configuration
export const BOOKING = {
  campspotUrl: 'https://www.campspot.com/book/redrockpondsrvresort/search',
  groupReservationMinimum: 3, // Number of sites for group discount
  lockingFeeWaivedForGroups: true
};

// Guest limits (used in reservation form dropdowns)
export const GUEST_LIMITS = {
  adults: {
    min: 1,
    max: 6
  },
  children: {
    min: 0,
    max: 5
  },
  pets: {
    min: 0,
    max: 5
  }
};
